import { memo } from 'react';
import { Box, Typography } from '@material-ui/core';
import ContractTable from '../common/ContractTable';
import { elStyle } from '../common/ContractTableHandlerCss';
import '../NormalViewContractDetail.css';
import Utils from '@/common/utils/utils';
import { renderDisplayPayment } from '../NormalViewContractDetailHanlder';
import { CONTRACT_STATUS } from '@/common/constant/NormalContractManagementConstant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import trI18n from '@/common/utils/trI18n';
import useTranslationSubscription from '@/hooks/useTranslation';

function UpdateContractConfirm({
    amountValue,
    advanceSetting,
    basicSetting,
    currentScreen,
    edition,
    paymentCycle,
    product,
    version,
    contractDetail
}) {
    useTranslationSubscription();
    
    const productName = !Utils.isEmptyObject(product) ? `${product.name}` : '';
    const editionName = !Utils.isEmptyObject(edition) ? `(${edition.name})` : '';

    return (
        <div className="contact-update-wrapper normal-collapse" style={{ overflow: 'hidden' }}>
            <Typography component="div" className="total-price">
                <Box className="price-label" {...elStyle.total_price_label} component="p">
                    {trI18n('LABEL-TITLE-CONFIRM-CONTRACT')}
                </Box>
                <Box className="payment-price" {...elStyle.payment_price}>
                    <Box component="span" {...elStyle.fw500}>
                        {trI18n('LABEL-PAYMENT-AMOUNT')}
                    </Box>
                    <Box component="span" {...elStyle.fz14}>
                        {`${amountValue} ${renderDisplayPayment(paymentCycle, contractDetail)}`}
                    </Box>
                </Box>
                { contractDetail.contractStatus === CONTRACT_STATUS.TRIAL && (<Box className="warning-icon" {...elStyle.warning_icon}>
                    <img
                        src="/assets/image/icon-listEmpty.svg"
                        alt="icon-warning"
                        style={{ opacity: 0.7, paddingTop: '5px' }}
                    />
                    <Box component="span" className="warning-content" {...elStyle.warning_content}>
                        {trI18n('LABEL-NOTI-MSG')}
                    </Box>
                </Box>)}
            </Typography>
            <Box className="contract-update-body">
                <Typography component="div" className="product-infomation">
                    <Box
                        component="p"
                        className="contract-confirm-label"
                        {...elStyle.contract_confirm_label}
                    >
                        {trI18n('CM-LABEL-PLAN')}
                    </Box>
                    <Box component="p" {...elStyle.fz14} fontWeight={400} p="16px">
                        <OverFlowTooltipWithTabsMui
                            className="normal-content d-inline-block w-full"
                            value={`${productName} ${editionName}`}
                        />
                    </Box>
                </Typography>

                {/* Basic setting */}
                <ContractTable
                    currentScreen={currentScreen}
                    settingData={basicSetting}
                    paymentCycle={paymentCycle}
                    product={product}
                />

                {/* Options */}
                {!Utils.isEmptyObject(version) &&
                    version?.moduleSetting?.advancedOptionSettings && (
                        <ContractTable
                            currentScreen={currentScreen}
                            isAdvanceSetting={true}
                            settingData={advanceSetting}
                            paymentCycle={paymentCycle}
                            product={product}
                        />
                    )}
            </Box>
        </div>
    );
}


export default memo(UpdateContractConfirm);